const ApiService = require("../../services/ApiService");

const state = () => ({
    categoryItems:[],
    itemsToDelete:[],
    crossSellingOverlay:[],
    manyBasketItems:[],
    detected:{
        ip:null,
        user:null,
        pid:null
    }
});

const mutations =
    {
        setManyBasketItems(state, items)
        {
            state.manyBasketItems = items;
        },
        setCrossSellingOverlay(state, items)
        {
            state.crossSellingOverlay = items;
        },
        setCategoryItems(state, categoryItems)
        {
            state.categoryItems = categoryItems;
        },
        setAllItemsToDelete(state, items)
        {
            state.itemsToDelete = items;
        },
        toggleItemToDelete(state, item)
        {
            const currentItems = state.itemsToDelete;

            if (currentItems.indexOf(item) > -1)
            {
                const newcurrentItems = [];

                for (let i = 0; i < currentItems.length; i++)
                {
                    if (currentItems[i] !== item)
                    {
                        newcurrentItems.push(currentItems[i]);
                    }
                }
                state.itemsToDelete = newcurrentItems;
            }
            else
            {
                state.itemsToDelete.push(item);
            }
        },
        setDetected(state, object)
        {
            state.detected = object;
        }
    };

const actions =
    {
        initCatItems({ commit })
        {
            return new Promise((resolve, reject) =>
            {
                ApiService.get("/getrandomcatitems/" + 102)
                    .done(response =>
                    {
                        commit("setCategoryItems", response.documents);
                        console.log("ausgeführt");
                        resolve(response.documents);
                    })
                    .fail(error =>
                    {
                        reject(error);
                    });
            });
        }
    };

const getters = {};

export default
{
    state,
    mutations,
    actions,
    getters
};
